<template>
  <v-container fluid fill-height class="no-results">
    <v-layout align-center justify-center>
      <div class="no-results--container">
        <v-icon class="grey--text">
          {{icon || "info"}}
        </v-icon>
        <div class="no-results--text">
          {{message || "No results"}}
        </div>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: ['icon', 'message']
}
</script>

<style lang="scss">
  .no-results--container {
    text-align: center;
    .v-icon {
      font-size: 100px;
    }
  }
</style>
